import Inputmask from 'inputmask-core';

export default class InputMask
{
    public startCaretPos: number = 0;
    
    protected input: HTMLInputElement;
    protected mask;
    
    constructor(node: string|HTMLInputElement, pattern: string)
    {
        if (typeof node === 'string') {
            node = document.querySelector(node) as HTMLInputElement;
        }

        this.input = node;
        
        this.mask = this.initInputMask(pattern);
        this.appendEvents();
    }

    protected initInputMask(pattern: string)
    {
        return new Inputmask({
            pattern: pattern,
            placeholderChar: '_',
        });
    }

    protected appendEvents()
    {
        this.input.addEventListener('click', () => {
            if (
                this.input.selectionStart !== this.mask.selection.start
                || this.input.selectionEnd !== this.mask.selection.end
            ) {
                this.setCaretPos();
            }
        });

        this.input.addEventListener('focus', () => {
            this.input.value = this.mask.getValue();
            this.setCaretPos();
        });

        this.input.addEventListener('input', e => {
            let event = e as InputEvent;

            switch (event.inputType) {
                case 'insertText': this.mask.input(event.data); break;
                case 'deleteContentBackward': this.mask.backspace(); break;
            }

            this.input.value = this.mask.getValue();
            this.setCaretPos();
            this.setValidationFlag();
        });

        this.input.addEventListener('blur', () => {
            if (this.getRawValue() === '') {
                this.input.value = '';
            }
        });
    }

    protected setValidationFlag()
    {
        this.input.dataset.valid = (this.mask.getValue().search('_') === -1).toString();
    }

    protected getRawValue(): string
    {
        return this.mask.getRawValue().replace(new RegExp(this.mask.placeholderChar + '+'), '');
    }

    protected setCaretPos()
    {
        if (this.mask.selection.start < this.startCaretPos) {
            this.mask.setSelection({start: this.startCaretPos, end: this.startCaretPos});
        }
        
        this.input.setSelectionRange(this.mask.selection.start, this.mask.selection.end);
    }
}
